<script>
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import { convertDateOnly } from "src/services/helpers";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let caseDetails = {};
</script>

{#if caseDetails.attribution !== "Unknown"}
	<CustomCollapseCard
		customClass="mb-4"
		title="Driver Information"
		isOpenDefault={true}
	>
		<div class="p-0">
			<Row>
				<Col class="col-4">
					<div class="description">Driver Name</div>
					<div class="value">{caseDetails.userInfo?.name || "-"}</div>
				</Col>
				<Col class="col-4">
					<div class="description">
						Class 3/3A/3C License Issuance Date
					</div>
					<div class="value">
						{#if caseDetails.userInfo?.drivingLicenses.length}
							{#each caseDetails.userInfo.drivingLicenses as { licenceClass, licenceIssueDate }}
								<div>
									<span>
										{licenceClass}, {convertDateOnly(
											licenceIssueDate
										)}
									</span>
								</div>
							{/each}
						{:else}
							-
						{/if}
					</div>
				</Col>
				<Col class="col-4">
					<div class="description">Licence Expiry Date</div>
					<div class="value">
						{#if caseDetails.userInfo?.drivingLicenses.length}
							{#each caseDetails.userInfo.drivingLicenses as { licenceExpiryDate }}
								<div>
									<span>
										{licenceExpiryDate &&
										licenceExpiryDate.startsWith("0001")
											? "Not applicable"
											: convertDateOnly(
													licenceExpiryDate
												)}
									</span>
								</div>
							{/each}
						{:else}
							-
						{/if}
					</div>
				</Col>
			</Row>

			<hr class="divider" />

			<Row>
				<Col class="col-4">
					<div class="description">Date of Birth</div>
					<div class="value">
						{convertDateOnly(caseDetails.userInfo?.dob) || "-"}
					</div>
				</Col>
				<Col class="col-4">
					<div class="description">CDW</div>
					<div class="value">
						{caseDetails.userInfo?.insurance || "-"}
					</div>
				</Col>
			</Row>
		</div>
	</CustomCollapseCard>
{/if}
